export const TASKS_PER_PAGE = '25'
